import type { SkillGroup } from '@portfolio/shared';
import type { JSX } from 'react';

import { ChipList } from '@/components/ui/Chip';
import { Card } from '@/components/ui/Card';

interface SkillsMatrixProps {
  groups: readonly SkillGroup[];
  headingLevel?: 'h3' | 'h4';
}

/**
 * Skills are grouped by capability. There are deliberately no proficiency bars:
 * a percentage next to "React" would be a number nobody can justify.
 */
export function SkillsMatrix({
  groups,
  headingLevel: Heading = 'h3',
}: SkillsMatrixProps): JSX.Element {
  return (
    <ul className="grid gap-5 md:grid-cols-2 xl:grid-cols-3">
      {groups.map((group) => (
        <Card as="li" key={group.id} className="flex flex-col">
          <Heading className="text-base">{group.title}</Heading>
          <p className="mt-2 text-sm text-muted">{group.description}</p>
          <ChipList
            items={group.skills}
            label={`${group.title} skills`}
            className="mt-5 border-t border-line pt-4"
          />
        </Card>
      ))}
    </ul>
  );
}
